import { isEqual, sortBy } from "lodash";

import { letters } from "@examspark/common";
import { Stem, StemChoice } from "@examspark/types";

import { getNewScore } from "./utils";

export const getChoiceKeys = (
  scoring?: Partial<Stem.Scoring>,
): Array<string> => {
  const actualKeys: Array<string> = [];

  for (const k in scoring?.options) {
    if (scoring?.options[k].isKey) {
      actualKeys.push(k);
    }
  }

  return sortBy(actualKeys);
};

export const getSelectedLetters = (
  stem: StemChoice,
  response: Stem.Response,
) => {
  const selected = response?.options;
  const options = stem.content.options.map((opt: any) => opt.id);
  console.log("getSelectedLetters", options, selected);

  const selectedLetters = selected
    ?.map((sel: string) => {
      const idx = options.findIndex((opt: string) => opt === sel);
      if (idx === -1) return null;
      return letters(idx).toUpperCase();
    })
    .filter((letter: string | null) => !!letter);

  console.log("selectedLetters", selectedLetters);
  return selectedLetters ?? [];
};

export const choice = (
  expected: StemChoice,
  actual: Partial<Stem.Response>,
) => {
  const score = getNewScore();
  const { scoring, config } = expected;

  if (config?.enableCustomScoring) {
    score.max = Number(config.maxScore || "1");
  } else {
    score.max = 1;
  }

  if (!actual?.options || actual.options.length === 0) {
    score.actual = 0;
    score.isScorable = true;
    return score;
  }

  if (config?.enableCustomScoring) {
    actual.options.forEach((optId) => {
      if (scoring?.options?.[optId]?.isKey) {
        if (scoring?.options?.[optId]?.score) {
          score.actual += Number(scoring.options[optId]?.score);
        } else {
          score.actual++;
        }
      } else {
        if (scoring?.options?.[optId]?.score) {
          score.actual += Number(scoring.options[optId]?.score);
        } else if (config?.defaultScore) {
          score.actual += Number(config.defaultScore);
        } else {
          score.actual += Number(-1);
        }
      }
    });
  } else {
    const actualKeys = getChoiceKeys(scoring);
    if (isEqual(actualKeys, sortBy(actual.options))) {
      score.actual = 1;
    }
  }

  return score;
};
